import $ from "jquery";

// Créer une layout en colonne si une liste est supérieure ou égale à 9
var list = $('.list--coloured-bullet');
list.each(function(){
    var li =  $(this).children();

    if(li.length >= 9) {
        $(this).addClass('column-layout');
    }
})

